import axios from "axios";

import { API_URL } from "./constants";

const publicFetch = axios.create({
  baseURL: API_URL,
});

export { publicFetch };
